import '../../App.css';
import ConvictionReview from '../tabs/convictionReview';
import Convictions from '../tabs/convictions';
import Withdrawals from '../tabs/withdrawals';
import QueryMX from '../tabs/queryMX';
import QueryCA from '../tabs/queryCA';
import { useState } from 'react';
import { useAuth } from "../../context/AuthContext.js";

function Homepage() {
  const [activeComponent, setActiveComponent] = useState("convictionReview");
  const {source, token, userState, email, roles} = useAuth();
  const defined = (v) => v !== undefined && v !== null && v !== "";
  const renderComponent = () => {
    switch (activeComponent) {
      case "convictionReview":
        return <ConvictionReview />;
      case "convictions":
        return <Convictions />;
      case "withdrawals":
        return <Withdrawals />;
      case "queryMX":
        return <QueryMX />;
      case "queryCA":
        return <QueryCA />;
      default:
        return null;
    }
  };


  return (
    <>
      <div class="btn-group btn-group-toggle" data-toggle="buttons" style={{width: '-webkit-fill-available'}}>
        <button
        className={`btn btn-secondary${activeComponent === "convictionReview" ? " active" : ""}`}
        id='review'
        onClick={() => setActiveComponent("convictionReview")}
    >
        Conviction Review
    </button>
    <button
        className={`btn btn-secondary${activeComponent === "convictions" ? " active" : ""}`}
        id='conviction'
        onClick={() => setActiveComponent("convictions")}
    >
        Convictions
    </button>
    <button
        className={`btn btn-secondary${activeComponent === "withdrawals" ? " active" : ""}`}
        id='withdrawal'
        onClick={() => setActiveComponent("withdrawals")}
    >
        Withdrawals
    </button>
    <button
        className={`btn btn-secondary${activeComponent === "queryMX" ? " active" : ""}`}
        id='mx'
        onClick={() => setActiveComponent("queryMX")}
    >
        Query MX/Other Countries
    </button>
      <button
          className={`btn btn-secondary${activeComponent === "queryCA" ? " active" : ""}`}
          id='ca'
          onClick={() => setActiveComponent("queryCA")}
      >
          Query Canada
      </button>
     
     </div>
     

      <div className="component-container">
        {renderComponent()}
      </div>
    </>
  );
}

export default Homepage;